<template>
  <div class="Center">
    <nav-vue index="2" />
   <div class="tea-products-container">
      <el-row :gutter="20">
        <el-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6" v-for="(item, index) in researchData" :key="index">
          <div class="tea-card">
            <div class="tea-image-container">
              <div class="rich-text-content" v-html="item.content"></div>
            </div>
            <div class="tea-name">{{ item.title }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <footer-vue></footer-vue>
  </div>
</template>

<script>
import NavVue from '../components/nav.vue'
import FooterVue from '../components/footer.vue'
import {researchIndex} from '@/uilt/api.js'
import config from '../mixin/config'
export default {
  components: { NavVue, FooterVue },
  mixins:[config],
  data(){
    return{
      listActive:null,
      list:['产品中心','研究成果','学术论文'],
      researchData:[],
      content:'',
    }
  },
  created(){
    this.getresearchIndex()
  },
  watch:{
      listActive(e){
        this.content=this.researchData[e].content
      }
  },
  methods:{
      Onlist(e){
        this.listActive=e
      },
      getresearchIndex(){
        researchIndex().then(res=>{
          this.researchData=res
          this.listActive=0
        })
      }
  }
}
</script>

<style lang="scss" scoped>
.tea-products-container {
  width: 1280px;
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
}

.tea-card {
  height: 300px;
  padding: 8px;
  border: 1px solid #c9a45c;
  border-radius: 4px;
  margin-bottom: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  
}

.tea-image-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  overflow: hidden;
  background-color: #fff;
}

.rich-text-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rich-text-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.tea-name {
  text-align: center;
  padding: 10px;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


</style>